<div class="approval-rule-create">
  <button type="button" class="lum-button" mat-button (click)="createEvent.emit()">
    <lum-ui-icon
      [cssClasses]="'mr-2-5'"
      icon="add-circle"
      color="#ffffff"
      width="20"
      height="20"
    ></lum-ui-icon>
    Create Approval Rule
  </button>
</div>
